import React from "react";
import Layout from "../components/layout";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import "./certificates.css";
// @ts-ignore
import iso9001 from "../images/certificates/SONO-9001.jpg";
// @ts-ignore
import iso12207 from "../images/certificates/SONO-12207.jpg";
// @ts-ignore
import iso18001 from "../images/certificates/SONO-18001.jpg";
// @ts-ignore
import iso25051 from "../images/certificates/SONO-25051.jpg";
// @ts-ignore
import iso27001 from "../images/certificates/SONO-27001.jpg";

interface CertificatesState {
	modalShown: boolean;
	modalTitle: string;
	modalImg: string;
}

class Certificates extends React.Component<{}, CertificatesState> {

	constructor(props: {}) {
		super(props);
		this.state = {
			modalShown: false,
			modalTitle: "",
			modalImg: ""
		}
	}

	certImage(title: string, image: string) {
		return (
			<React.Fragment>
				<h3>{title}</h3>
				<img src={image} className="img-thumbnail" alt="" onClick={() => this.showImage(title, image)}/>
			</React.Fragment>
		)
	}

	showImage(modalTitle: string, modalImg: string) {
		this.setState({
			modalShown: true,
			modalTitle,
			modalImg
		})
	}

	toggleModal() {
		this.setState({
			modalShown: !this.state.modalShown
		});
	}

	render() {
		return (
			<Layout
				pageTitle="SONO GRC - Certificates"
				className="quality-certificates"
				header={
					<div className="content container">
						<h1><span>SONO</span> Quality Certificates</h1>
						<div className="row">
							<div className="col-12 col-md-4">
								{this.certImage("TS EN ISO 9001:2015", iso9001)}
							</div>
							<div className="col-12 col-md-4">
								{this.certImage("ISO/IEC 12207", iso12207)}
							</div>
							<div className="col-12 col-md-4">
								{this.certImage("TS EN ISO 18001:2007", iso18001)}
							</div>
						</div>
					</div>
				}
				body={
					<React.Fragment>
						<div className="container-fluid second-row">
							<div className="container">
								<div className="row">
									<div className="col-12 col-md-4 offset-md-1">
										{this.certImage("ISO/IEC 25051", iso25051)}
									</div>
									<div className="col-12 col-md-4 offset-md-2">
										{this.certImage("TS EN ISO 27001:2013", iso27001)}
									</div>
								</div>
							</div>
						</div>

						<Modal isOpen={this.state.modalShown} toggle={() => this.toggleModal()}>
							<ModalHeader toggle={() => this.toggleModal()}>
								{this.state.modalTitle}
							</ModalHeader>
							<ModalBody>
								<img src={this.state.modalImg} style={{width: "100%"}} alt=""/>
							</ModalBody>
						</Modal>
					</React.Fragment>
				}
			/>
		)
	}

}

export default () => <Certificates/>;